import React from 'react';
import { makeStyles, Grid, Typography, Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  pageSubTitle: {
    fontSize: 18,
    marginTop: 20,
    marginBottom: 20,
    color: theme.palette.secondary.light,
    fontFamily: 'Open Sans, sans-serif',
  },
  copy: {
    fontSize: 20,
    marginBottom: 20,
    fontFamily: 'Open Sans, sans-serif',
  },
  chart: {
    width: '100%',
    height: 'auto',
  },
}));

const Intro = ({ print, printed }) => {
  const classes = useStyles();
  return (
    <>
      <Grid container>
        <Grid item md={print ? 12 : 6} sm={12} xs={12}>
          <Box pr={1}>
            <Typography className={classes.copy}>
              Responding with immediacy is a high priority at Paul Hastings and an imperative in
              this highly competitive legal market. As a junior associate, it can be challenging to
              understand the difference between what is urgent and what is important. Complete the
              assessment below, to see how you can learn to <i>Live above the Line.</i>
            </Typography>
          </Box>
        </Grid>
        {!print && !printed && (
          <Grid item md={6} sm={12} xs={12}>
            <img
              className={classes.chart}
              alt="Chart"
              src={`${process.env.PUBLIC_URL}/img/mojo_survey.png`}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Intro;
